import axios from 'axios'
import {
  getCsrfToken,
  getSessionToken,
} from '@futures-platform/connectors/session'

const baseUrl = process.env.REACT_APP_VOTING_BASE_URL_API
const publicURL = process.env.REACT_APP_PUBLIC_URL
const DRUPAL_API_URL = process.env.REACT_APP_DRUPAL_API_URL
const tagServiceURL = process.env.REACT_APP_TAG_SERVICE_API_URL

// async function httpRequest(method, path, payload = null) {
//   console.log('`${baseUrl}/${path}`', `${baseUrl}/${path}`)
//   return axios({
//       method,
//       url: `${baseUrl}/${path}`,
//       headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${getSessionToken()}`
//       },
//       withCredentials: true,
//       data: payload || null
//   })
// }

async function httpRequest(
  urlParam,
  method,
  path,
  payload = null,
  headers = {},
) {
  return axios({
    method,
    url: `${urlParam}/${path}`,
    headers: {
      'X-CSRF-Token': getCsrfToken(),
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getSessionToken()}`,
      ...headers,
    },
    withCredentials: true,
    data: payload || null,
  })
}

// url: `${DRUPAL_API_URL}/v1.0/${path}`,
export const fetcher = {
  translation: async (from, to, payload) => {
    return await httpRequest(
      'https://go2.futuresplatform.com',
      'POST',
      `translation-api/translate/${from}/${to}`,
      payload,
      {
        'Content-Type': 'text/plain',
      },
    )
  },
  getListLangs: async () => {
    return await httpRequest(`${DRUPAL_API_URL}`, 'GET', `v1.0/languages`)
  },
  editPreferredTrans: async (userId, payload) => {
    return await httpRequest(
      `${DRUPAL_API_URL}`,
      'PATCH',
      `v1.0/user/${userId}`,
      payload,
    )
  },
  storeImgToDb: async (gid, imgFile) => {
    return await httpRequest(
      publicURL,
      'PUT',
      !!gid ? `file/${gid}/image` : `file/image`,
      imgFile,
      {
        'Content-Type': imgFile?.type || 'application/octet-stream',
      },
    )
  },

  getUserName: async (userId) => {
    return await httpRequest(
      `${DRUPAL_API_URL}`,
      'GET',
      `v1.0/user/${userId}`,
    ).then((u) => u.data.displayName)
  },

  getUserNameData: async (userId) => {
    return await httpRequest(`${DRUPAL_API_URL}`, 'GET', `v1.0/user/${userId}`)
  },
  tagScenarioCard: async (groupId, scenarioCardId, tagUri) => {
    const property = 'fp:docs/props/has'
    const { error } = await httpRequest(
      tagServiceURL,
      'POST',
      `?group=${groupId}`,
      {
        tag: tagUri,
        content: `fp:docs/scenario/${scenarioCardId}`,
        property,
      },
    )
    return Boolean(error)
  },
  removeTagScenarioCard: async (groupId, scenarioCardId, tagUri) => {
    const property = 'fp:docs/props/has'
    const { error } = await httpRequest(
      tagServiceURL,
      'POST',
      `remove?group=${groupId}`,
      {
        tag: tagUri,
        content: `fp:docs/scenario/${scenarioCardId}`,
        property,
      },
    )
    return Boolean(error)
  },
  exportPdfReport: async (payload) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${publicURL}/api/export-pdf`,
        headers: {
          'X-CSRF-Token': getCsrfToken(),
          'Content-Type': 'application/json',
          Accept: 'application/pdf',
          Authorization: `Bearer ${getSessionToken()}`,
        },
        data: payload,
        responseType: 'arraybuffer',
        withCredentials: true,
      })

      if (!response.data || response.data.byteLength === 0) {
        console.error('Empty PDF data received from server')
        return {
          success: false,
          error: 'Empty PDF data received',
        }
      }

      // Create a blob from the PDF data
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const blobUrl = URL.createObjectURL(blob)

      // Create the filename with improved sanitization for international characters
      const sanitizeForFilename = (str) => {
        if (!str) return ''
        // Only replace characters invalid in filenames across operating systems
        // Preserve Unicode characters including Arabic, Chinese, etc.
        return str.replace(/[\\/:*?"<>|]/g, '_').trim()
      }

      const sanitizedTitle = payload.title
        ? sanitizeForFilename(payload.title)
        : ''
      const exportDate =
        payload.export_date || new Date().toISOString().split('T')[0]

      // Add current time to filename
      // const now = new Date()
      // const timeStr = `${String(now.getHours()).padStart(2, '0')}-${String(
      //   now.getMinutes(),
      // ).padStart(2, '0')}`

      const filename = sanitizedTitle
        ? `${sanitizedTitle} FP ${exportDate}.pdf`
        : `scenario-export - FP ${exportDate}.pdf`

      // Create and trigger download link
      const downloadLink = document.createElement('a')
      downloadLink.style.display = 'none'
      downloadLink.href = blobUrl
      downloadLink.download = filename
      document.body.appendChild(downloadLink)

      // Trigger download
      downloadLink.click()

      // Clean up resources
      setTimeout(() => {
        document.body.removeChild(downloadLink)
        URL.revokeObjectURL(blobUrl)
      }, 1000)

      return {
        success: true,
        downloaded: true,
        filename,
        size: response.data.byteLength,
      }
    } catch (error) {
      console.error('Error exporting PDF:', error)
      return {
        success: false,
        error: error.message,
        details: error.response
          ? {
              status: error.response.status,
              data: error.response.data,
            }
          : null,
      }
    }
  },
}
